/**
 * Combine all reducers in this file and export the combined reducers.
 */

import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";

import loginReducer from "./loginReducer";
import projectReducer from "./ProjectReducer";
import tokenReducer from "./tokenReducer";
import ProfileReducer from "./ProfileReducer";
import NotificationsReducer from "./notificationsReducer";
import globalSearchReducer from "./globalSearchReducer";
import activityTimelineReducer from "reducers/activityTimelineReducer";

/**
 * Merges the main reducer with the router state and dynamically injected reducers
 */
export default function createReducer(injectedReducers = {}) {
  const rootReducer = combineReducers({
    routing: routerReducer,
    projectReducer: projectReducer,
    loginReducer: loginReducer,
    tokenReducer: tokenReducer,
    profileReducer: ProfileReducer,
    notificationsReducer: NotificationsReducer,
    globalSearchReducer: globalSearchReducer,
    activityTimelineReducer: activityTimelineReducer,
    ...injectedReducers,
  });
  return rootReducer;
}
